<template>
  <modal :modal-key="'new_achievement_modal'"
         @close="$emit('close')"
         class="modal--welcomeback modal--zero-balance"
         :body-style="'achievement'">
    <template slot="header">
      <h1>{{ getTranslations.home_modals_achievements_locked_title }} {{ achievementInfo.achievementLevelName }}</h1>
      <img class="pinicon" :src="achievementInfo.image" alt="">
    </template>
    <template slot="body">
      <h2 class="modal_sub">{{ getTranslations.home_modals_achievements_new_achievement_title }}</h2>
      <p>{{ getTranslations.home_modals_achievements_new_achievement_description1 }}
        {{ achievementInfo.prizeValue }}
        {{ getTranslations.home_modals_achievements_new_achievement_description2 }}
        {{ achievementInfo.achievementLevelName }}!
      </p>
      <h2 class="modal_sub"> {{ getTranslations.home_modals_achievements_new_achievement_earned }}</h2>
      <achievement-reward :achievement-info="achievementInfo" :category-name="categoryName" @read="(value) => $emit('read', value)"/>
      <div class="fb">
        <p v-if="facebookFunctionality"></p>
        <a href="#" @click.prevent="shareToFb()" v-if="facebookFunctionality">
          <div class="facebook_share_avatar">
            <div class="facebook_share_icon">
              <img src="static/images/fb_icon.svg"></div>
            <div class="facebook_share_text">
              <p>{{ getTranslations.home_fb_share_share }}</p>
            </div>
          </div>
        </a>
      </div>
    </template>
  </modal>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';
import AchievementReward from '@/components/home/achievements/AchievementReward';
import FacebookMixin from '@/common/mixins/facebookIntegration';

export default {
  name: 'new-achievement',
  mixins: [FacebookMixin],
  components: {
    AchievementReward,
    Modal,
  },
  props: {
    categoryName: String,
    achievementInfo: Object,
  },
  data() {
    return {
      action: 'ACHIEVEMENT',
      redirectUrl: '',
      fb_error: false,
    };
  },
  created() {
    this.redirectUrl = `${window.location.href}/${this.achievementInfo.achievementLevelName}/${this.getLocale || localStorage.getItem('locale')}/`;
    if (this.facebookFunctionality) {
      this.forceFbToScrapNewMetadata(this.redirectUrl, () => {
        // eslint-disable-next-line
        console.log('successful scrapping!');
      });
    }
  },
  methods: {
    showError() {
      this.fb_error = true;
    },
    shareToFb() {
      this.fb_error = false;
      this.points = this.getFbPoints;
      this.share(
        this.userDetails.facebookId,
        this.userDetails.id,
        // eslint-disable-next-line
        () => { console.log('successful achievement share!'); },
        this.showError,
      );
    },
  },
  computed: {
    ...mapState('common', [
      'facebookFunctionality',
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/achievements/NewAchievement.vue